import { pgTable, uuid, text, boolean, timestamp, index } from "drizzle-orm/pg-core";
import { customerGroups } from "./customer-groups.js";

export const customers = pgTable(
  "customers",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    email: text("email").notNull().unique(),
    passwordHash: text("password_hash"),
    firstName: text("first_name"),
    lastName: text("last_name"),
    phone: text("phone"),
    customerGroupId: uuid("customer_group_id")
      .notNull()
      .references(() => customerGroups.id),
    companyName: text("company_name"),
    companyRegNo: text("company_reg_no"),
    vatNumber: text("vat_number"),
    legalAddress: text("legal_address"),
    marketingConsent: boolean("marketing_consent").notNull().default(false),
    marketingConsentAt: timestamp("marketing_consent_at", { withTimezone: true }),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
    googleId: text("google_id").unique(),
    lastLoginAt: timestamp("last_login_at", { withTimezone: true }),
    emailVerifiedAt: timestamp("email_verified_at", { withTimezone: true }),
    // Vīnoga team can exempt a specific customer from Dokobit age verification
    // (e.g. a known/vetted account) — set from the panelis customer page.
    skipAgeVerification: boolean("skip_age_verification").notNull().default(false),
    // Per-customer "Saņemt atdzesētu" perk (free chilled handover). Off by
    // default; enabled from the panelis customer page. Only flagged, signed-in
    // customers see the option at checkout.
    chilledDeliveryEnabled: boolean("chilled_delivery_enabled").notNull().default(false),
    // Per-customer "Pēcapmaksa ar bankas pārskaitījumu": checkout offers a
    // bank-transfer method that completes the order without Montonio payment.
    bankTransferEnabled: boolean("bank_transfer_enabled").notNull().default(false),
    // Legal alcohol-hours gate override: flagged customers may confirm
    // alcohol orders 24/7 (Mon–Sat 10–20 / Sun 10–18 applies otherwise).
    // Auto-enabled when a profile turns B2B via a legal-entity order.
    afterHoursEnabled: boolean("after_hours_enabled").notNull().default(false),
    // Moneo customer code for this client's invoices (owner 2026-10-08).
    // When set, pushMoneoInvoice books the order under this code instead of
    // the shared retail code from moneo_settings.config.retailCustCode. The
    // code must already exist in Moneo — we only reference it, never create.
    moneoCustCode: text("moneo_cust_code"),
  },
  (t) => ({
    customerGroupIdx: index("customers_customer_group_id_idx").on(t.customerGroupId),
  })
);

export type Customer = typeof customers.$inferSelect;
export type NewCustomer = typeof customers.$inferInsert;
